import Check from "@mui/icons-material/Check"
import Stack from "@mui/material/Stack"
import Step from "@mui/material/Step"
import StepConnector, {
    stepConnectorClasses,
} from "@mui/material/StepConnector"
import { StepIconProps } from "@mui/material/StepIcon"
import StepLabel from "@mui/material/StepLabel"
import Stepper from "@mui/material/Stepper"
import { styled } from "@mui/material/styles"
import { ReactElement } from "react"

import { useScreenSize } from "../../../hooks/useScreenSize"

/** Styled custom stepper connector */
const StyledConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
        top: 10,
        left: "calc(-50% + 24px)",
        right: "calc(50% + 24px)",
    },
    [`&.${stepConnectorClasses.active}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            borderColor: theme.palette.primary.main,
        },
    },
    [`&.${stepConnectorClasses.completed}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            borderColor: theme.palette.success.main,
        },
    },
    [`& .${stepConnectorClasses.line}`]: {
        borderColor:
            theme.palette.mode === "dark"
                ? theme.palette.grey[800]
                : theme.palette.grey[400],
        borderTopWidth: 3,
        borderRadius: 1,
    },
}))

/** Styled step icons */
const StyledStepIcons = styled("div")<{ ownerState: { active?: boolean } }>(
    ({ theme, ownerState }) => ({
        color:
            theme.palette.mode === "dark"
                ? theme.palette.grey[700]
                : theme.palette.grey[400],
        display: "flex",
        height: 22,
        alignItems: "center",
        ...(ownerState.active && {
            color: theme.palette.primary.main,
        }),
        "& .AppStepperIcons-completedIcon": {
            color: theme.palette.success.main,
            zIndex: 1,
            fontSize: 30,
        },
        "& .AppStepperIcons-circle": {
            width: 12,
            height: 12,
            borderRadius: "50%",
            backgroundColor: "currentColor",
        },
    })
)

/* Step icons to be injected into component */
const AppStepperIcons = (props: StepIconProps): ReactElement => {
    const { active, completed, className } = props

    return (
        <StyledStepIcons ownerState={{ active }} className={className}>
            {completed ? (
                <Check className="AppStepperIcons-completedIcon" />
            ) : (
                <div className="AppStepperIcons-circle" />
            )}
        </StyledStepIcons>
    )
}

interface IAppStepper {
    stepLabels: string[]
    currentStepIndex: number
}

/**
 * Reusable stepper with custom defined steps. Labels are hidden from view
 * on mobile devices.
 */
const AppStepper = ({
    stepLabels,
    currentStepIndex,
}: IAppStepper): ReactElement => {
    const { isTabletOrMob } = useScreenSize()
    return (
        <Stack sx={{ width: "100%" }} spacing={4}>
            <Stepper
                alternativeLabel
                activeStep={currentStepIndex}
                connector={<StyledConnector />}
            >
                {stepLabels.map((label: string) => (
                    <Step key={label}>
                        <StepLabel StepIconComponent={AppStepperIcons}>
                            {isTabletOrMob ? "" : label}
                        </StepLabel>
                    </Step>
                ))}
            </Stepper>
        </Stack>
    )
}
export default AppStepper
